import { useEffect, useState } from "react";
import Alfamart from "./Alfamart";
import Notfound from "../../Notfound";
import Mandiri from "./Mandiri";
import Bri from "./Bri";
import Bni from "./Bni";
import Bsi from "./Bsi";
import Bjb from "./Bjb";
import Cimb from "./Cimb";
import Permata from "./Permata";
import BriLink from "./Brilink";
import Indomaret from "./Indomaret";
import Bca from "./Bca";
import Bss from "./Bss";
import Dana from "./E_dana";
import LinkAja from "./E_linkaja";
import ShopeePay from "./E_shopeepay";
import Gopay from "./E_Gopay";
import Qris from "./E_qris";
import Ovo from "./E_ovo";


const Xendit = ({channel, invoice_id, user_id}) => {
    const [views, setViews] = useState("");

    const getViewChannel = (channel, invoice_id, user_id) => {
        switch(channel) {
            case 'ALFAMART' :
                setViews(<Alfamart invoice_id={invoice_id} user_id={user_id}/>)
                break;
            case 'INDOMARET' :
                setViews(<Indomaret invoice_id={invoice_id} user_id={user_id}/>)
                break;
            case 'MANDIRI' :
                setViews(<Mandiri invoice_id={invoice_id} user_id={user_id}/>)
                break;
            case 'BCA' :
                setViews(<Bca invoice_id={invoice_id} user_id={user_id}/>)
                break;
            case 'BSS' :
                setViews(<Bss invoice_id={invoice_id} user_id={user_id}/>)
                break;
            case 'BRI' :
                setViews(<Bri invoice_id={invoice_id} user_id={user_id}/>)
                break;
            case 'BNI' :
                setViews(<Bni invoice_id={invoice_id} user_id={user_id}/>)
                break;
            case 'BSI' :
                setViews(<Bsi invoice_id={invoice_id} user_id={user_id}/>)
                break;
            case 'BJB' :
                setViews(<Bjb invoice_id={invoice_id} user_id={user_id}/>)
                break;
            case 'CIMB' :
                setViews(<Cimb invoice_id={invoice_id} user_id={user_id}/>)
                break;
            case 'PERMATA' :
                setViews(<Permata invoice_id={invoice_id} user_id={user_id}/>)
                break;
            case 'DANA' :
                setViews(<Dana invoice_id={invoice_id} user_id={user_id}/>)
                break;
            case 'LINKAJA' :
                setViews(<LinkAja invoice_id={invoice_id} user_id={user_id}/>)
                break;
            case 'SHOPEEPAY' :
                setViews(<ShopeePay invoice_id={invoice_id} user_id={user_id}/>)
                break;
            case 'GOPAY' :
                setViews(<Gopay invoice_id={invoice_id} user_id={user_id}/>)
                break;
            case 'QRIS' :
                setViews(<Qris invoice_id={invoice_id} user_id={user_id}/>)
                break;
            case 'OVO' :
                setViews(<Ovo invoice_id={invoice_id} user_id={user_id}/>)
                break;
            // case 'BRILINK' :
            //     setViews(<BriLink invoice_id={invoice_id} user_id={user_id}/>)
            //     break;
            default :
                setViews(<Notfound />)
                break;
        }
    }

    useEffect(() => {
        const init = () => {
            getViewChannel(channel, invoice_id, user_id)
        };
        init();
    }, [invoice_id, user_id, channel])
    
    return (
        <>{views}</>
    )
}

export default Xendit;